import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { TABS } from './RecordPaymentPanel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecordPaymentTabs = ({
  selectedTab,
  setSelectedTab,
  shouldDisableTabs
}) => {
  return /*#__PURE__*/_jsxs(UITabs, {
    className: "m-bottom-4",
    defaultSelected: selectedTab,
    onSelectedChange: setSelectedTab,
    use: "enclosed",
    children: [/*#__PURE__*/_jsx(UITab, {
      tabId: TABS.ADD_NEW,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoicesHighlightCard.modals.recordPaymentTabs.recordNew"
      }),
      disabled: shouldDisableTabs
    }), /*#__PURE__*/_jsx(UITab, {
      tabId: TABS.ADD_EXISTING,
      "data-test-id": "record-existing-payment-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoicesHighlightCard.modals.recordPaymentTabs.applyExisting"
      }),
      disabled: shouldDisableTabs
    })]
  });
};
export default RecordPaymentTabs;